export const ADMIN_LAYOUT = 'AdminLayout';

// meta.access controls who can reach each admin screen:
// - 'admin'    → admin or manager only.
// - 'category' → also reachable by photographers (per-category granted access).
export const AdminRouter = [
  {
    path: '/administrator',
    name: 'IndexAdmin',
    component: () => import('@/views/Admin/Index.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/preferences',
    name: 'AdminPreferences',
    component: () => import('@/views/Admin/Preferences/Index.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/events/:event_id/category/:category_id/file-manager',
    name: 'FileManager',
    component: () => import('@/views/Admin/Events/FileManager.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'category' },
  },
  {
    path: '/administrator/events/:event_id/category/:category_id/presets',
    name: 'PhotoPresets',
    component: () => import('@/views/Admin/Events/Presets.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'category' },
  },
  {
    path: '/administrator/discounts',
    name: 'Discounts',
    component: () => import('@/views/Admin/Discounts/Index.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/discounts/new',
    name: 'DiscountsNew',
    component: () => import('@/views/Admin/Discounts/New.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/discounts/:id/edit',
    name: 'DiscountsEdit',
    component: () => import('@/views/Admin/Discounts/Edit.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/discounts/:id/coupons',
    name: 'DiscountsCoupons',
    component: () => import('@/views/Admin/Discounts/Coupons.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
  {
    path: '/administrator/events/:event_id/category/:category_id/video-file-manager',
    name: 'VideoUploadWithSignedUrl',
    component: () => import('@/views/Admin/Videos/Index.vue'),
    meta: { layout: ADMIN_LAYOUT, access: 'admin' },
  },
];
